import { env } from '@repo/env';
import type { MarketplaceRateTableTabName } from '@repo/supergraph/structuredContent/hydration/MarketplaceRateTable/constants';

export const EXPLORE_MORE_BASE_URL = `${env.NEXT_PUBLIC_NW_URL}/rates/banking`;

type TabConfig = {
  description: string;
  linkPath: string;
};

export const TAB_CONFIG = {
  Savings: {
    description:
      'A savings account is a place where you can store money securely while earning interest.',
    linkPath: '/savings-accounts',
  },
  'Cash Management': {
    description:
      'These cash accounts combine services and features similar to checking, savings and/or investment accounts in one product. Cash management accounts are typically offered by non-bank financial institutions.',
    linkPath: '/cash-management-accounts',
  },
  CD: {
    description:
      'CDs (certificates of deposit) are a type of savings account with a fixed rate and term, and usually have higher interest rates than regular savings accounts.',
    linkPath: '/cd-accounts',
  },
  Checking: {
    description: 'Checking accounts are used for day-to-day cash deposits and withdrawals.',
    linkPath: '/checking-accounts',
  },
  'Money Market': {
    description:
      'Money market accounts pay rates similar to savings accounts and have some checking features.',
    linkPath: '/money-market-accounts',
  },
} as const satisfies Record<MarketplaceRateTableTabName, TabConfig>;
